import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dossier } from 'src/app/suivi-portefeuille/core/model/dossier';
import { DemandeResurmeDTO } from 'src/app/suivi-portefeuille/core/model/resurme/demande-resurme-dto';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Request } from "src/app/parametrage/core/model/request";
import { DossierService } from 'src/app/suivi-portefeuille/core/service/dossier.service';
import { RequestService } from 'src/app/parametrage/core/service/request.service';

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-portefeuille-tabs",
  templateUrl: "./portefeuille-tabs.component.html",
  styleUrls: ["./portefeuille-tabs.component.scss"]
})
export class PortefeuilleTabsComponent implements OnInit {
  pressButton: Boolean = false;
  numDossier: String;
  dossier: Dossier;
  alert: Alert = null;
  demandeResurme: DemandeResurmeDTO;
  requestEncours: Request;
  constructor(
    private _router: Router,
    private fb: FormBuilder,
    private _dossierService: DossierService,
    public activeModal: NgbActiveModal,
    private _requestService: RequestService
  ) {}

  ngOnInit() {
  //  this.numDossier = this.demandeResurme.refDossierCoreBanking;
    this.getDossierByNumDossier(this.numDossier);
    this.getRequestEncoursAttentePaiementByNumDossier(this.numDossier);

  }

  getDossierByNumDossier(numDossier) {
    this._dossierService.getDossierByNumDossier(numDossier).subscribe(
      data => {
        this.dossier = data;
      },
      error => {
        console.log(error);
      }
    );
  }
  getRequestEncoursAttentePaiementByNumDossier(numDossier) {
    this._requestService
      .getRequestEncoursAttentePaiementByNumDossier(numDossier)
      .subscribe(
        data => {
          this.requestEncours = data;
        },
        error => {
          console.log(error);
        }
      );
  }
  analyserDossier() {
    this._dossierService.analyserDossier(this.numDossier).subscribe(
      data1 => {
        this.alert = {
          type: "success",
          message: "Analyse efféctuée"
        };

        this.getDossierByNumDossier(this.numDossier);
      },
      error1 => {
        console.log(error1);
        this.alert = {
          type: "danger",
          message: error1.error.message
        };
      }
    );
  }

  lancerProcedure() {
    this._dossierService.lancerProcedure(this.numDossier).subscribe(
      data1 => {
        this.alert = ({
          type: "success",
          message: "Dossier lancé"
        });
        this.requestEncours = data1;
      },
      error1 => {
        this.alert = ({
          type: "danger",
          message: error1.error.message
        });
        console.log(error1);
      }
    );
  }
  close(alert: Alert) {
    this.alert = null;
  }

 
}
